import React, { FC, ReactNode, useEffect, useRef, useState } from "react";
import { dataSubArray } from "./Drawer.fixtures";
import { useLocation } from "react-router-dom";
import { Disclosure } from "@headlessui/react";
import { useAppDispatch } from "store/hooks";
import { refreshFlowBuilder } from "reducers/flow-builder.reducer";
// import laudspeakerIcon from "../../assets/images/laudspeakerHeaderIcon.svg";
import useHover from "hooks/useHover";
import { Link } from "react-router-dom";
import laudspeakerIcon from "../../assets/images/dragonhub-logo.svg";

const classNames = (...classes: string[]) => classes.filter(Boolean).join(" ");

interface NavigationItem {
  id: string;
  imgIcon: string;
  text: string;
  type: string;
  link: string;
  children?: NavigationItem[];
}

const navigation = dataSubArray;

export interface ResponsiveDrawerProps {
  expandable?: boolean;
  statusWidget?: ReactNode
}

const ResponsiveDrawer: FC<ResponsiveDrawerProps> = ({ expandable, statusWidget }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const drawerRef = useRef<HTMLDivElement>(null);
  const isHovered = useHover(drawerRef);

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (!expandable) {
      setIsExpanded(true);
      return;
    }

    setIsExpanded(isHovered);
  }, [isHovered, location.pathname]);

  useEffect(() => {
    dispatch(refreshFlowBuilder());
  }, [location.pathname]);

  return (
    <div
      className={`${expandable
        ? "absolute transition-[width] [&_.notexapndable]:hover:!scale-100 w-[50px] hover:!w-[230px]"
        : "flex min-w-[230px]"
        } top-0 left-0 px-[10px] text-[14px] text-[#111827] leading-[22px] font-normal font-roboto z-[999999999999] border-collapse bg-[#F3F4F6] border border-[#E5E7EB] h-screen`}
      ref={drawerRef}
    >
      <div className="flex flex-col gap-2 flex-grow">
        <div className={`w-full h-[50px] flex items-center gap-5`}>
          <div className="min-w-[30px] min-h-[30px] flex items-center justify-center">
            <img
              className="min-w-[15px] min-h-[20px] max-w-[23px] max-h-[35px]"
              src={laudspeakerIcon}
            />
          </div>

          <svg
            className={`${expandable
              ? "notexapndable scale-0 transition-[width] delay-1000"
              : ""
              } whitespace-nowrap ${!isExpanded && "hidden"}`}
            width="102"
            height="30"
            viewBox="0 0 102 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <text
              x="0"
              y="15"
              font-family="Arial"
              font-size="20"
              fill="#6366f1"
            >
              Dragonhub
            </text>
          </svg>
        </div>
        <div className="w-full flex flex-1 flex-col gap-2">
          {navigation.map((navigationItem) => (
            <div
              className="w-full flex justify-center items-center"
              id={navigationItem.id}
              key={navigationItem.id}
            >
              {navigationItem.children ? (
                <div className="w-full">
                  <Disclosure
                    defaultOpen={navigationItem.children.some((child) =>
                      location.pathname.includes(child.link)
                    )}
                  >
                    {({ open }) => (
                      <div className="flex flex-col gap-2">
                        <Disclosure.Button className="w-full">
                          <div
                            className={`relative w-full h-[40px] flex items-center gap-2 select-none cursor-pointer`}
                          >
                            <div className="flex items-center justify-center min-w-[30px] min-h-[30px] max-w-[30px] max-h-[30px] rounded">
                              <img src={navigationItem.imgIcon} />
                            </div>
                            <span
                              className={`${expandable
                                ? "notexapndable scale-0 transition-[width] delay-150"
                                : ""
                                } whitespace-nowrap ${expandable && !isExpanded && "hidden"
                                }`}
                            >
                              {navigationItem.text}
                            </span>
                            <div
                              className={`${expandable
                                ? "notexapndable scale-0 transition-[width] delay-150 absolute top-1/2 -translate-y-1/2 right-[5px]"
                                : ""
                                } ${open ? "" : "rotate-180"} ${expandable && isExpanded && "!delay-0"
                                }`}
                            >
                              <svg
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.58573 6.94449C7.97626 7.33501 8.53028 7.41416 8.82317 7.12127C9.11606 6.82837 9.03692 6.27435 8.64639 5.88383L5.81797 3.0554C5.57464 2.81208 5.26784 2.68964 5.00029 2.70275C4.73263 2.68949 4.42564 2.81193 4.18218 3.05538L1.35376 5.88381C0.963233 6.27433 0.884088 6.82835 1.17698 7.12125C1.46987 7.41414 2.02389 7.33499 2.41442 6.94447L5.00007 4.35882L7.58573 6.94449Z"
                                  fill="#4B5563"
                                />
                              </svg>
                            </div>
                          </div>
                        </Disclosure.Button>
                        <Disclosure.Panel>
                          <div className="flex flex-col gap-2">
                            {navigationItem.children.map((child) => (
                              <Link
                                className={`w-full h-[40px] flex items-center select-none cursor-pointer ${!expandable || isExpanded
                                  ? "pl-[22px]"
                                  : "justify-center"
                                  }`}
                                id={child.id}
                                to={child.link}
                                key={child.id}
                              >
                                <div
                                  className={`rounded flex items-center w-full gap-2 ${isExpanded &&
                                    location.pathname.includes(child.link)
                                    ? "bg-[#6366F1] text-white"
                                    : ""
                                    }`}
                                >
                                  <div
                                    className={`flex items-center justify-center min-w-[30px] min-h-[30px] max-w-[30px] max-h-[30px] rounded ${!isExpanded &&
                                      location.pathname.includes(child.link)
                                      ? "bg-[#6366F1]"
                                      : ""
                                      }`}
                                  >
                                    <img
                                      className={`${location.pathname.includes(
                                        child.link
                                      ) && "invert"
                                        }`}
                                      src={child.imgIcon}
                                    />
                                  </div>
                                  <span
                                    className={`${expandable
                                      ? "notexapndable scale-0 transition-[width] delay-1000"
                                      : ""
                                      } whitespace-nowrap inline-block overflow-hidden ${!isExpanded && "hidden"
                                      }`}
                                  >
                                    {child.text}
                                  </span>
                                </div>
                              </Link>
                            ))}
                          </div>
                        </Disclosure.Panel>
                      </div>
                    )}
                  </Disclosure>
                </div>
              ) : (
                <Link
                  className={`w-full h-[40px] flex items-center select-none cursor-pointer ${expandable && isExpanded ? "" : "justify-center"
                    }`}
                  to={navigationItem.link}
                  id={navigationItem.id}
                >
                  <div
                    className={`rounded flex items-center w-full gap-2 ${isExpanded &&
                      location.pathname.includes(navigationItem.link)
                      ? "bg-[#6366F1] text-white"
                      : ""
                      }`}
                  >
                    <div
                      className={`flex items-center justify-center min-w-[30px] min-h-[30px]  max-w-[30px] max-h-[30px] rounded ${!isExpanded &&
                        location.pathname.includes(navigationItem.link)
                        ? "bg-[#6366F1]"
                        : ""
                        }`}
                    >
                      <img
                        className={`${location.pathname.includes(navigationItem.link) &&
                          "invert"
                          }`}
                        src={navigationItem.imgIcon}
                      />
                    </div>
                    <span
                      className={`${expandable
                        ? "notexapndable scale-0 transition-[width] delay-1000"
                        : ""
                        } whitespace-nowrap ${expandable && !isExpanded && "hidden"
                        }`}
                    >
                      {navigationItem.text}
                    </span>
                  </div>
                </Link>
              )}
            </div>
          ))}
        </div>
        <div key="statusWidget" className="w-full flex items-center gap-5">
          {statusWidget}
        </div>
      </div>
    </div>
  );
};
export default ResponsiveDrawer;
